import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataService } from 'src/app/data.service';
import { MENU_ITEM_IDS } from 'src/app/storefront/tv-vertical-menu/tv-vertical-menu.constants';

@Injectable({
  providedIn: 'root',
})
export class RouteHistoryService {
  history: string[] = [];

  private isBackNavigation = false;

  constructor(
    private router: Router,
    private readonly location: Location,
    private readonly dataService: DataService
  ) {}

  init() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event) => {
        if (this.isBackNavigation) {
          this.isBackNavigation = false; // reset after a back
          return; // Don't push on back navigation
        }

        const lastUrl = this.history[this.history.length - 1];
        const currentPath = new URL(
          event.urlAfterRedirects,
          window.location.origin
        ).pathname;
        const lastPath = new URL(lastUrl || '', window.location.origin)
          .pathname;

        if (currentPath !== lastPath) {
          //Removing middle routes from history if pushing same route exisiting in the history
          const existingIndex = this.history.lastIndexOf(
            event.urlAfterRedirects
          );

          if (existingIndex !== -1) {
            this.history = this.history.slice(0, existingIndex + 1);
          } else {
            // Check if this is a replaceUrl navigation
            const navigation = this.router.getCurrentNavigation();
            if (navigation?.extras?.replaceUrl) {
              // Replace the last entry instead of pushing
              if (this.history.length > 0) {
                this.history[this.history.length - 1] = event.urlAfterRedirects;
              } else {
                this.history.push(event.urlAfterRedirects);
              }
            } else {
              this.history.push(event.urlAfterRedirects);
            }
          }
        }
      });
  }

  private getPreviousUrl(): string | null {
    if (this.history.length > 1) {
      this.isBackNavigation = true;
      this.history.pop(); // remove current
      return this.history[this.history.length - 1]; // return previous
    }
    return null;
  }

  getCurrentUrl(): string {
    return this.history[this.history.length - 1];
  }

  resetHistory(): void {
    this.history = [];
  }

  goBack(): void {
    const previousUrl = this.getPreviousUrl();
    const storefrontUrlMap = {
      search: MENU_ITEM_IDS.SEARCH,
      'my-aha': MENU_ITEM_IDS.MY_AHA,
    };

    for (const [urlPart, menuItemId] of Object.entries(storefrontUrlMap)) {
      if (previousUrl?.includes(urlPart)) {
        this.dataService.previousTabId = menuItemId;
        break;
      }
    }
    if (previousUrl) {
      this.location.back();
    }
  }

  async goBackMultiple(noOfPages: number): Promise<void> {
    try {
      for (let i = 0; i < noOfPages; i++) {
        this.location.back();
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    } catch (error) {
      console.error('Error during goBackMultiple navigation:', error);
    }
  }

  replaceHistory(url: string, data?: any) {
    this.router.navigateByUrl(url, { state: data, replaceUrl: true });
  }
}
